import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";

const i18Cmp = "dashboard.total_performance.direction";

@Component({
  selector: "er-direction-indicator",
  templateUrl: "./direction-indicator.component.html",
  standalone: true,
  imports: [CommonModule, TranslocoPipe, MatIconModule, TranslocoPipe],
})
export class DirectionIndicatorComponent {
  @Input() value: number = 0;
  @Input() comparedWith!: string;
  @Input() upDirectionLabel: string = "";
  @Input() downDirectionLabel: string = "";
}
